<template>
  <div>
    <label
      v-if="label"
      class="block text-sm font-medium leading-5 text-gray-700"
      :for="id"
    >{{ label }}:</label>
    <div class v-if="!running">
      <div v-if="value && preview" class="mb-4">
        <img :src="value" alt class="w-64" />
      </div>

      <div class="flex">
        <label :for="id" class="btn hover:bg-gray-200 cursor-pointer">
          <i class="fa fa-upload"></i>
          Upload from disk
        </label>
        <input
          :id="id"
          ref="input"
          v-bind="$attrs"
          class="hidden form-input w-full"
          :class="{ error: errors.length }"
          type="file"
          @change="fileUpload($event.target.files[0])"
        />
      </div>
    </div>
    <div v-else class="h-16 flex items-center justify-start">
      <i class="fa fa-spin fa-spinner mr-2"></i> Uploading...
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  inheritAttrs: false,
  data() {
    return {
      running: false
    }
  },
  mounted() {
    // this.$refs.hubBrowser.visible = true
  },
  props: {
    id: {
      type: String,
      default() {
        return `image-input-${this._uid}`
      }
    },
    value: {},
    label: String,
    errors: {
      type: Array,
      default: () => []
    },
    preview: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    fileUpload(file) {
      this.running = true
      let data = new FormData()
      data.append('file', file)
      axios
        .post(route('files.store'), data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.$emit('upload', response.data)
          this.running = false
        })
    },
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    }
  }
}
</script>

<style lang="scss" scoped></style>
